import { formatDateToYYYYMMDD } from "../utils/DateParser";
import { Campaign } from "@/store/campaigns/campaigns";
import { rootGetters } from "@/main";

export interface YearDates {
    startDate: Date;
    endDate: Date;
}


export function getCurrentYearDates(): YearDates {
    const now = new Date();
    const currentYear = now.getFullYear();

    const startDate = new Date(currentYear, now.getMonth(), now.getDate());

    const endDate = new Date(currentYear, 11, 31);

    return { startDate, endDate };
}


export function isTechCampaignConditionsMet(campaign: Campaign): boolean {
    const techShopId = rootGetters.tech_shop_id;
    if (!techShopId) return false;

    if (!campaign.brand) return false;
    if (!campaign.shop || campaign.shop.id !== techShopId) return false;
    if (campaign.extra_info !== "tech") return false;
    if (campaign.strategy !== "") return false;

    if (!campaign.date_to) return false;
    const { endDate } = getCurrentYearDates();
    const endDateStr = formatDateToYYYYMMDD(endDate);
    const campaignEndDateStr = formatDateToYYYYMMDD(campaign.date_to);
    if (campaignEndDateStr !== endDateStr) return false;

    return true;
}

export function prepareTechCampaignSearchParams(brandPk: string): {
    page: number;
    per_page: number;
    brand_pk: string;
    shop_id: string;
    end_date: string;
    extra_info: string;
} {
    const techShopId = rootGetters.tech_shop_id;
    if (!techShopId) {
        throw new Error("Не указан shop_id в конфигурации приложения (VUE_APP_TECH_SHOP_ID)");
    }

    const { endDate } = getCurrentYearDates();

    return {
        page: 1,
        per_page: 1,
        brand_pk: brandPk,
        shop_id: techShopId.toString(),
        end_date: formatDateToYYYYMMDD(endDate),
        extra_info: "tech",
    };
}

export async function prepareTechCampaignData(): Promise<{
    shop: any;
    startDate: Date;
    endDate: Date;
    strategy: string;
    extra_info: string;
} | null> {
    const techShopId = rootGetters.tech_shop_id;
    if (!techShopId) {
        return null;
    }

    const { startDate, endDate } = getCurrentYearDates();

    const { useShopsStore } = await import("@/store/catalog_data/shops");
    const shopsStore = useShopsStore();
    await shopsStore.getItems("", [techShopId.toString()], false, false, 0, 50);

    let techShop = null;
    if (shopsStore.itemList && shopsStore.itemList.length > 0) {
        techShop = shopsStore.itemList.find((s: any) => s.id === techShopId);
    }

    if (!techShop) {
        return null;
    }

    return {
        shop: techShop,
        startDate,
        endDate,
        strategy: "",
        extra_info: "tech",
    };
}

